import CheckItensBody from "../Componentes/AuditInterna/CheckItensBody";
import NavBar from "../Componentes/NavBar";
import { useParams } from "react-router-dom";

const AuditoriaCheck = () => {

    const { id } = useParams();

    return(
        <>
            <NavBar
                title="ITENS PENDENTES AUDITORIA"
                navTo={ `/modulo/ssma/auditoria-interna/${ id }` }
            />
            <CheckItensBody/>
        </>
    )

}

export default AuditoriaCheck;